export const BizLocationType = {
  DOMESTIC: "DOMESTIC",
  OVERSEAS: "OVERSEAS",
  UNKNOWN: "UNKNOWN",
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type BizLocationType = (typeof BizLocationType)[keyof typeof BizLocationType];
